<div class="vmpLabel">{{ caption | translate }}</div>
